<div class="bmc-connectors-interface__container" *ngIf="selectedConnector">
  <div class="bmc-connectors-interface__header">
    <div class="bmc-connectors-interface__display-name">
      <bzg-icon [nameIcon]="'icon-bizagi-thin'" [size]="29"></bzg-icon>
      <label class="bmc-connectors-interface__display-name__text">{{displayName}}</label>
    </div>
    <label>{{selectedConnectorType.displayName}} {{'CONNECTORS.VERSION' | translate}}
      {{selectedConnectorType.version}}</label>
  </div>
  <div class="bmc-connectors-interface__description">
    <label class="bmc-connectors-interface__description__title">{{'CONNECTORS.DESCRIPTION_DETAIL' | translate}}</label>
    <label class="bmc-connectors-interface__description__value">{{description}}</label>
  </div>

  <div class="bmc-connectors-interface__tabs-section">
    <bzg-tab-set (onSelectTab)="selectedTab = $event.index">
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}"
        displayName="{{'CONNECTORS.PARAMETERS' | translate | uppercase}}">
        <div class="bmc-connectors-fields__empty-container" *ngIf="!hasSystemProperties()">
          <span>{{'CONNECTORS.NO_PARAMETERS_AVAILABLE' | translate}}</span>
        </div>
        <div class="bmc-connectors-fields" *ngIf="hasSystemProperties()">
          <div>
            <form #connectorForm="ngForm">
              <bzg-table [(model)]="systemProperties">
                <ng-template bzgTableColumn width="40%" title="{{'CONNECTORS.PROPERTY' | translate}}"
                  let-dataItem="dataItem">
                  {{dataItem.name}}
                  <span *ngIf="dataItem.required">&nbsp;*</span>
                </ng-template>
                <ng-template bzgTableColumn width="60%" title="{{'CONNECTORS.VALUE' | translate}}"
                  let-dataItem="dataItem">
                  <bzg-input *ngIf="!hasDefaultValue(dataItem)" name="inputPro{{dataItem.name}}"
                    [(ngModel)]=" dataItem.value" [required]="dataItem.required" [compact]="'true'"
                    [readonly]="dataItem.readonly" type="{{dataItem.passwordmode ? 'password':'text'}}"
                    style="width: 100%;">
                    <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD'|translate}}</bzg-required-error>
                  </bzg-input>
                  <bzg-select *ngIf="hasDefaultValue(dataItem)" id="sel{{dataItem.name}}"
                    [placeholder]="'GLOBAL.SELECT_ONE'|translate" [compact]="'true'" [(value)]="dataItem.value"
                    style="width: 100%;">
                    <bzg-option *ngFor="let item of dataItem.propertyvalues" [value]="item">{{item}}
                    </bzg-option>
                  </bzg-select>
                </ng-template>
              </bzg-table>
            </form>
          </div>
        </div>
      </bzg-tab-item>
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 1}"
        displayName="{{'CONNECTORS.AUTH_PARAMETERS' | translate | uppercase}}">
        <div class="bmc-connectors-auth-fields">
          <div class="bmc-connectors-auth-parameters__auth-methods">
            <label for="selAuthFlow" class="select-label">{{'CONNECTORS.SSL_CERTIFICATE'|translate}}
            </label>
            <bzg-checkbox [checked]="selectedConnector.content.enableSSLCertificate"
              [(ngModel)]="selectedConnector.content.enableSSLCertificate"> {{'CONNECTORS.SSL_ENABLE' |
              translate}}
            </bzg-checkbox>
            <div style="display: flex; align-items: center;" class="bz-space--stack-s">
              <bzg-button-secondary class="bz-space--inline-s"
                [disabled]="!selectedConnector.content.enableSSLCertificate" [size]="'s'" type="button"
                (click)="fileInput.click()">
                <span> {{'CONNECTORS.UPLOAD_FILE' | translate}}</span>
                <input #fileInput type="file" (change)="onSSLInput($event)" style="display:none;" />
              </bzg-button-secondary>
              <div *ngIf="selectedConnector.content.enableSSLCertificate"> {{selectedConnector.content.sslFileName ||
                'CONNECTORS.SSL_SELECT' |
                translate }}</div>
            </div>
            <div class="select-oauth">
              <div class="selectAuth">
                <label for="selAuthFlow" class="select-label auth-label">{{'CONNECTORS.AUTH_METHOD'|translate}}
                  <span>&nbsp;*</span></label>
                <bzg-select id="selAuthFlow" [placeholder]="'GLOBAL.NONE' | translate" [compact]="'true'"
                  [value]="selectedAuthenticationMethod" (valueChange)="selectAuthType($event)">
                  <bzg-option *ngFor="let authenticationMethod of availableAuthenticationMethods"
                    [value]="authenticationMethod">
                    {{'CONNECTORS.' + (authenticationMethod.authenticationtype | uppercase) | translate}}
                  </bzg-option>
                </bzg-select>
              </div>
              <div *ngIf="needAuthorization()" class="authorize">
                <div class="botton-authrize">
                  <bzg-button-secondary [size]="'s'" (click)="authorize()">
                    <span>{{'CONNECTORS.AUTHORIZE'|translate}}
                      <img src="assets/icons/12x_check-mark.svg" *ngIf="authenticated()"
                        style="vertical-align: middle;"> </span>
                  </bzg-button-secondary>
                </div>
                <img src="assets/icons/16x_plus.svg" (click)=addItem() class="icon-auth">
                <img src="assets/icons/16x_delete.svg" (click)=deleteItem() *ngIf="showTrash()" class="icon-auth">
              </div>
            </div>
          </div>
          <bzg-table [(model)]="authenticationProperties" [showPaginator]="false"
            *ngIf="authenticationProperties && authenticationProperties.length > 0">
            <ng-template bzgTableColumn width="40%" title="{{'CONNECTORS.PROPERTY' | translate}}"
              let-dataItem="dataItem">
              <bzg-checkbox *ngIf="dataItem.canDelete" [(ngModel)]="dataItem.selected"
                style="vertical-align: baseline;">
              </bzg-checkbox>
              <bzg-input *ngIf="dataItem.canDelete" [(ngModel)]="dataItem.name" [compact]="'true'" style="width: 100%;">
              </bzg-input>
              <span *ngIf="!dataItem.canDelete">{{dataItem.name}} </span>
              <span *ngIf="dataItem.required && !dataItem.readonly ">&nbsp;*</span>
            </ng-template>
            <ng-template bzgTableColumn width="60%" title="{{'CONNECTORS.VALUE' | translate}}" let-dataItem="dataItem">
              <bzg-input name="input{{dataItem.name}}" [(ngModel)]="dataItem.value" [required]="dataItem.required"
                [readonly]="dataItem.readonly" [compact]="'true'" type="{{dataItem.passwordmode ? 'password':'text'}}"
                style="width: 100%;">
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD'|translate}}</bzg-required-error>
              </bzg-input>
              <img src="assets/icons/16x_copy.svg" class="copy-style" title="{{'GLOBAL.COPY_TEXT' | translate}}"
                (click)=copyToclipboard(dataItem.value) *ngIf="dataItem.readonly">
            </ng-template>
          </bzg-table>
        </div>

        <div class="impersonation-block" *ngIf="showImpersonationCheck()">
          <bzg-checkbox [checked]="selectedConnector.content.enableImpersonation"
            [(ngModel)]="selectedConnector.content.enableImpersonation" class="authorize-check">
            <b>{{'CONNECTORS.ENABLE_IMPERSO'|translate}}</b>
          </bzg-checkbox>
          <label class="authorize-label">{{'CONNECTORS.IMPERSONATION_TXT'|translate}}</label>
        </div>

      </bzg-tab-item>
    </bzg-tab-set>
  </div>
</div>

<biz-auth-code-grant #authcodegrant></biz-auth-code-grant>